export default "__VITE_ASSET__BKQBjGUK__"